// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UUJ-","colBig":"styles_colBig__rj9r3","colSmall":"styles_colSmall__2Xy4N","shopifyNameWrapper":"styles_shopifyNameWrapper__2Y4Ox"};